export default __webpack_public_path__ + "static/media/AntyLucy_16.0a6733a4.jpg";